// globals defined in esbuild config
/* global DISPLAY_TITLE, DISPLAY_VERSION, NODE_ENV, REDUX_LOGGER, VERSION, VERSION_HASH */
import { Globals } from '@wf-sl/common-utilities'

try {
    Globals.set('DISPLAY_TITLE', DISPLAY_TITLE)
    Globals.set('DISPLAY_VERSION', DISPLAY_VERSION)
    Globals.set('NODE_ENV', NODE_ENV)
    Globals.set('REDUX_LOGGER', REDUX_LOGGER)
    Globals.set('VERSION', VERSION)
    Globals.set('VERSION_HASH', VERSION_HASH)
} catch (e) {
    console.error(e)
}

Globals.set('TOKEN_REFRESH_INTERVAL_MINUTES', 30) // minutes
Globals.set('DEFAULT_PUSH_THROTTLING_INTERVAL', 10000) // milliseconds

// For map usages enable following API access keys and provide according values
// Globals.set('API_CLIENT_ID_GOOGLE', '')
// Globals.set('API_KEY_MIXPANEL_PROD', '')
// Globals.set('API_KEY_MIXPANEL_DEV', '')
// Globals.set('API_KEY_GOOGLE', '')
// Globals.set('API_KEY_TOMTOM', '')
// Globals.set('TOMTOM_LOW_EMISSION_ZONES_API_KEY', '')
// Globals.set('TOMTOM_EXTENDED_ROUTING_API_KEY', '')
// Globals.set('TOMTOM_GEOCODING_API_KEY', '')
// Globals.set('TOMTOM_GEOCODING_BATCH_API_KEY', '')
// Globals.set('TOMTOM_MATRIX_ROUTING_API_KEY', '')
// Globals.set('TOMTOM_REACHABLE_RANGE_API_KEY', '')
// Globals.set('TOMTOM_ROUTING_API_KEY', '')
// Globals.set('TOMTOM_SEARCH_CHARGING_STATION_AVAILABILITY_API_KEY', '')
// Globals.set('TOMTOM_SEARCH_CHARGING_STATIONS_API_KEY', '')
// Globals.set('TOMTOM_SECURE_TRUCK_PARKING_ROUTING_API_KEY', '')

// For URL parameter overrides get the search params
const urlQueryParams = new URLSearchParams(window?.location?.search)

// The effectively used environment for version toggles can be overridden by URL query parameter 'env'.
// To have that overridden environment also available after route changes, it is stored in Globals object and
// evaluated in selectEnvironmentOrderAndVersion from t3-connected-widgets.
const environmentOverride = urlQueryParams.get('env')
if (environmentOverride != null) {
    Globals.set('ENVIRONMENT_OVERRIDE', environmentOverride)
}
const reduxLoggerOverride = urlQueryParams.get('enableReduxLogger')
if (reduxLoggerOverride != null) {
    Globals.set('REDUX_LOGGER', !!reduxLoggerOverride)
}
